import dayjs, { type Dayjs } from 'dayjs';

type DateTimeValue = string | number | Date | Dayjs;

const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

/**
 * 格式化接口返回的时间点。输入带偏移量时，dayjs 会按浏览器本地时区显示。
 */
export function formatLocalDateTime(
  value: DateTimeValue | null | undefined,
  format = 'YYYY-MM-DD HH:mm:ss',
): string {
  if (value === null || value === undefined || value === '') return '';
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format(format) : '';
}

/** 格式化不带时间语义的日期，避免通过 UTC 转换造成跨日。 */
export function formatLocalDate(value: string | null | undefined): string {
  if (!value || !DATE_ONLY_PATTERN.test(value)) return '';
  const parsed = dayjs(value);
  return parsed.isValid() && parsed.format('YYYY-MM-DD') === value ? value : '';
}

/**
 * 把日期控件产生的本地墙上时间序列化为带本地偏移量的 ISO 字符串。
 * 不能改用 toISOString()，因为它会把本地时间转换成 UTC。
 */
export function toLocalOffsetISOString(
  value: DateTimeValue | null | undefined,
): string | undefined {
  if (value === null || value === undefined || value === '') return undefined;
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('YYYY-MM-DDTHH:mm:ssZ') : undefined;
}
